export default function scrollSmoothTo(elementId = '__next', additionalOffset = 80) {
  const element = document.getElementById(elementId)
  const top = element.offsetTop <= additionalOffset ? element.offsetTop : element.offsetTop - additionalOffset
  window.scrollTo({
    top,
    behavior: 'smooth',
  })
}
